var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import gql from 'graphql-tag';
// STL-2226: claimHome is coupled with saveHome to ensure that users
// are able to see this home in their saved homes & receive corresponding
// home report emails
export var claimHomeMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    mutation ClaimHome(\n        $zpid: ID!\n        $propertyClaimType: PropertyClaimType!\n        $propertyClaimSourceType: PropertyClaimSourceType!\n    ) {\n        claimHome(\n            zpid: $zpid\n            propertyClaimType: $propertyClaimType\n            propertyClaimSourceType: $propertyClaimSourceType\n        ) {\n            success\n            error\n        }\n        saveHome(zpid: $zpid)\n    }\n"])));
export var claimHome = function claimHome(apolloClient, zpid, propertyClaimSourceType) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(apolloClient.mutate({
      mutation: claimHomeMutation,
      variables: {
        propertyClaimSourceType: propertyClaimSourceType,
        propertyClaimType: 'OWNERSHIP',
        zpid: zpid
      }
    })).then($return, $error);
  });
};
//# sourceMappingURL=claimUtils.js.map